import * as React from "react";
function SvgIcUpload(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.044 4L5 8.067l.375.65 6.294-3.635V17.31h.75V5.082l6.294 3.635.375-.65L12.044 4zM5.672 19.898H18.44v.75H5.672v-.75z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcUpload;
